var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#f1f1f1",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.621 12.468a.27.27 0 0 0-.269.27v13.828c0 .15.121.271.27.271h15.525a.27.27 0 0 0 .268-.27V12.738a.27.27 0 0 0-.268-.271H10.62z",
    stroke: "#000",
    strokeWidth: 0.717,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.34 12.545-2.511-2.468A.27.27 0 0 0 23.64 10H13.13a.268.268 0 0 0-.187.077l-2.51 2.468a.272.272 0 0 0 .187.465h15.53a.272.272 0 0 0 .188-.465",
    stroke: "#000",
    strokeWidth: 0.717,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.717,
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M16.983 26.855h2.766V12.991h-2.766z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7941E",
    d: "m13.784 22.782 2.387 2.403-2.387-2.403"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.717,
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M19.175 10.007h-1.619l-.573 2.985h2.766l-.574-2.985"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.2b210fa947376f1b0b96b9cf74be1fa6.svg";
export { ForwardRef as ReactComponent };